
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Popconfirm, Radio, Upload, Button, Icon, Divider } from 'antd';
import isEmail from 'validator/lib/isEmail';

import { IconAdd, IconDelete } from '../../../../../../../data/assets/icons';
import { MODULE_MESSAGE, MODULE_CONFIG } from '../../../../../../../data/config/urls';
import { showMessage } from '../../../../../../../data/config/utils';
import { AGENT_INVITATION_WITH } from '../../../../../../../data/config/constants';

import InputItem from '../../../../../../../components/form/inputitem';
import SelectItem from '../../../../../../../components/form/selectitem';
import ErrorBoundary from '../../../../../../../components/errorboundary';

class AgentsInvitationForm extends React.PureComponent {
  state = {
    email_error: {},
    password_error: {},
    is_invite_method_selected: false,
  };

  inviteMethodSelected = () => {
    this.setState({ is_invite_method_selected: true });
    this.props.onClickAddMoreAgent();
  }

  onChangeInputItem = (index, event) => {
    const { onChange } = this.props;
    const name = event.target.name;
    const value = event.target.value;
    if (index >= 0) {
      onChange(name, value, index);
    }
  }

  onChangeConfirmPass = (index, e) => {
    const { onChange, new_agents } = this.props;
    const confirmPassword = e.target.value;
    if (index >= 0) {
      if (confirmPassword == new_agents[index].password) {
        this.setState({
          password_error: {
            ...this.state.password_error,
            [index]: "",
          }
        });
      } else {
        this.setState({
          password_error: {
            ...this.state.password_error,
            [index]: "Confirm password must be same as password!",
          }
        })
      }
      onChange('confirmPassword', confirmPassword, index);
    }
  };

  onChangeEmail = (index, e) => {
    const { onChange } = this.props;
    const email = e.target.value;
    if (index >= 0) {
      if (isEmail(email)) {
        this.setState({
          email_error: {
            ...this.state.email_error,
            [index]: "",
          }
        });
      } else {
        this.setState({
          email_error: {
            ...this.state.email_error,
            [index]: "Email id is not valid",
          }
        })
      }
      onChange('email', email, index);
    }
  };

  onChangeRole = (index, role) => {
    const { onChange } = this.props;
    if (index >= 0) {
      onChange('role', role, index);
    }
  };

  onChangeGroup = (index, group) => {
    const { onChange } = this.props;
    if (index >= 0) {
      onChange('group', group, index);
    }
  };

  onRemove = () => {
    const { getAgentsWithcsv } = this.props;
    getAgentsWithcsv([]);
  };

  validateCsvHeaders = headers => {
    if (headers)
      for (let i = 0; i < headers.length; i++) {
        const header_text = headers[i].replace(/\s/g, "").toLowerCase();
        switch (header_text) {
          case 'email': headers[i] = 'email';
            break;
          case 'username': headers[i] = 'userName';
            break;
          case 'firstname': headers[i] = 'firstName';
            break;
          case 'lastname': headers[i] = 'lastName';
            break;
          case 'role': headers[i] = 'role';
            break;
          case 'password': headers[i] = 'password';
            break;
          case 'confirmpassword': headers[i] = 'confirmPassword';
            break;
        }
      }
    return headers
  }

  beforeUpload = file => {
    const { getAgentsWithcsv, role_options } = this.props;
    if (file && file.type === "text/csv") {
      var reader = new FileReader();
      reader.onload = e => {
        var texto = e.target.result;
        var result = [];
        var lines = texto.split(/\r\n|\n/);
        var headers = lines[0].split(",");
        headers = this.validateCsvHeaders(headers);
        if ((headers && headers.length > 0) || (lines && lines.length > 1)) {
          if (lines.length <= MODULE_CONFIG.MEMBERS.MAX_INVITE_AGENT_COUNT_USING_CSV + 1) {
            let hasErrorInCsv = false;
            for (var i = 1; i < lines.length; i++) {
              var obj = {};
              var currentline = lines[i].split(",");
              for (var j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentline[j];
              }
              if (obj.email && obj.email.trim().length > 0) {
                obj.invitationWith = AGENT_INVITATION_WITH.EMAIL;
              } else if (obj.userName && obj.userName.trim().length > 0) {
                obj.invitationWith = AGENT_INVITATION_WITH.USER_NAME;
              } else {
                hasErrorInCsv = true;
                showMessage('warning', `Row ${i} data is not valid in csv please fix it and upload again.`);
                break;
              }
              const index = role_options.findIndex(role => role.value === obj.role);
              if (index === -1) {
                hasErrorInCsv = true;
                showMessage('warning', `selected role in Row ${i} is not valid please fix it before upload.`);
                break;
              }
              obj.group = ['General'];
              result.push(obj);
            }
            if (!hasErrorInCsv) {
              getAgentsWithcsv(result);
              this.setState({ is_invite_method_selected: true });
            }
          } else {
            showMessage('warning', `you can not invite more than ${MODULE_CONFIG.MEMBERS.MAX_INVITE_AGENT_COUNT_USING_CSV} agents at a time`);
          }
        } else {
          showMessage('warning', 'selected csv file has no valid data, please see sample.csv for example.');
        }
      };
      reader.readAsText(file);
    }
    return false;
  };

  render() {
    const { new_agents, role_options, group_options, onConfirmDeleteAgent, onClickAddMoreAgent } = this.props;
    const { email_error, password_error, is_invite_method_selected } = this.state;
    if (is_invite_method_selected) {
      return (
        <div className="ori-pad-15">
          {
            new_agents && new_agents.map((agent, index) => {
              return (
                <ErrorBoundary key={index}>
                  <div className="ori-t-pad-10">
                    <div className="ori-animated ori-fade-in ori-relative ori-bg-default ori-border-radius-4 ori-l-pad-15 ori-tb-pad-10 ori-r-pad-30 ori-b-mrgn-10" >
                      <div className="ori-absolute ori-bg-default ori-lr-pad-15 ori-tb-pad-3 ori-align-left ori-align-top-neg-12 ori-tl-border-radius-4 ori-tr-border-radius-4 ori-font-xs">{`Agent ${index + 1}`} </div>
                      <Popconfirm overlayClassName="ori-zindex-99999" placement="topRight" title="Are you sure delete this agent?" okText="Yes" cancelText="No" onConfirm={onConfirmDeleteAgent.bind(this, index)}>
                        <div className="ori-absolute ori-pad-5 ori-align-right-5 ori-align-top-7  ori-font-light-hover-primary">
                          <IconDelete size={18} />
                        </div>
                      </Popconfirm>
                      <div className="ori-flex-row ori-flex-jc ori-b-pad-10">
                        <Radio.Group size='small' name="invitationWith" value={agent.invitationWith} onChange={this.onChangeInputItem.bind(this, index)} >
                          <Radio.Button className="ori-font-normal ori-font-xs" value="email">Email</Radio.Button>
                          <Radio.Button className="ori-font-normal ori-font-xs" value="userName">Username</Radio.Button>
                        </Radio.Group>
                      </div>
                      <Row gutter={10}>
                        <Col xs={24} sm={12}>
                          <InputItem title="first name" placeholder="Enter first name" name="firstName" value={agent.firstName} onChange={this.onChangeInputItem.bind(this, index)} />
                        </Col>
                        <Col xs={24} sm={12}>
                          <InputItem title="last name" placeholder="Enter last name" name="lastName" value={agent.lastName} onChange={this.onChangeInputItem.bind(this, index)} />
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col xs={24} sm={12}>
                          {
                            agent.invitationWith === AGENT_INVITATION_WITH.EMAIL ?
                              <InputItem title="Email" type="email" placeholder="Enter email id" value={agent.email} message={email_error[index]} onChange={this.onChangeEmail.bind(this, index)} /> :
                              <InputItem title="username" type="text" placeholder="Enter username" name="userName" value={agent.userName} onChange={this.onChangeInputItem.bind(this, index)} />
                          }
                        </Col>
                        <Col xs={24} sm={12}>
                          <SelectItem title="Role" placeholder="Select role" options={role_options} value_key="value" value={agent.role} onChange={this.onChangeRole.bind(this, index)} is_option_object_type />
                        </Col>
                      </Row>
                      {
                        agent.invitationWith === AGENT_INVITATION_WITH.USER_NAME &&
                        <Row gutter={10}>
                          <Col xs={24} sm={12}>
                            <InputItem title="Password" type="password" placeholder="Enter password" name="password" value={agent.password} onChange={this.onChangeInputItem.bind(this, index)} />
                          </Col>
                          <Col xs={24} sm={12}>
                            <InputItem title="Confirm Password" type="password" placeholder="Enter password" value={agent.confirmPassword} message={password_error[index]} onChange={this.onChangeConfirmPass.bind(this, index)} />
                          </Col>
                        </Row>
                      }
                      <SelectItem title="Group" mode="multiple" placeholder="Select group" options={group_options} value_key="name" value={agent.group} onChange={this.onChangeGroup.bind(this, index)} is_option_object_type />
                    </div>
                  </div>
                </ErrorBoundary>
              );
            })
          }
          <div className="ori-cursor-ptr ori-font-primary ori-tb-pad-5 ori-flex" onClick={onClickAddMoreAgent}>
            <IconAdd size={18} /><span className="ori-l-pad-5 ori-font-sm ">Invite More Agent</span>
          </div>
        </div>
      );
    } else {
      return (
        <div className="ori-text-center ori-pad-20">
          <div className="ori-flex-row ori-flex-jc">
            <p className="ori-font-md">Invite agent using csv file</p>
            <a href={MODULE_CONFIG.MEMBERS.SAMPLE_CSV_URL} className='ori-font-light ori-link-primary ori-l-mrgn-10 ori-font-sm' download>( download sample csv* )</a>
          </div>
          <p className="ori-font-light ori-b-mrgn-10">{MODULE_MESSAGE.MEMBERS.AGENTS.invite_using_csv}</p>
          <Upload className="ori-mt-fileUploaderContainer" accept=".csv" showUploadList={false} beforeUpload={this.beforeUpload} onRemove={this.onRemove}>
            <div className="ori-pad-10 ori-font-light-hover-primary ori-bg-default ori-flex-column ori-flex-jc ori-border-dashed-default-hover-primary ori-border-radius-4" style={{ height: '200px' }}>
              <Icon type="plus" style={{ fontSize: '50px' }} />
              <p className="ori-t-mrgn-10 ori-font-md">select a csv file</p>
            </div>
          </Upload>
          <Divider>OR</Divider>
          <p className="ori-font-md">Invite agent by manually filling form</p>
          <p className="ori-font-light ori-b-mrgn-10">{MODULE_MESSAGE.MEMBERS.AGENTS.invite_manually}</p>
          <Button type="primary" onClick={this.inviteMethodSelected}>Manually Invite</Button>
        </div>
      );
    }
  }
}

AgentsInvitationForm.propTypes = {
  new_agents: PropTypes.array.isRequired,
  role_options: PropTypes.array,
  group_options: PropTypes.array,
  onChange: PropTypes.func,
  onConfirmDeleteAgent: PropTypes.func,
  onClickAddMoreAgent: PropTypes.func,
  getAgentsWithcsv: PropTypes.func
};

AgentsInvitationForm.defaultProps = {
  new_agents: [],
  role_options: [],
  group_options: [],
  onChange: () => { },
  onConfirmDeleteAgent: () => { },
};

export default AgentsInvitationForm;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/agents/components/agentsinvitationform/index.js